module.exports = __webpack_public_path__ + "static/media/projectPic7.08af9a58.png";